<app-header></app-header>
<div class="content_wrapper">
    <div class="panel-quotes-view">
        <div class="an-top">
            <div class="summary-mentions">
                <div class="spinner-border"></div>
                <h3>Quotes</h3>
            </div>
            <div class="bt-top">
                <button type="button" class="submit-mention btn" (click)="sentimant_filter(0)">All</button>
                <button type="button" class="submit-mention btn" (click)="sentimant_filter(1)">Positive</button>
                <button type="button" class="submit-mention btn" (click)="sentimant_filter(-1)">Negative</button>
                <div class="popover-wrapper">
                    <input type="text"
                           ngxDaterangepickerMd
                           [(ngModel)]="selected"
                           [alwaysShowCalendars]="alwaysShowCalendars"
                           [ranges]="ranges"
                           [showClearButton]="true"
                           [showCancel]="true"
                           [linkedCalendars]="true"
                           [locale]="{applyLabel: 'Apply'}"
                           (datesUpdated)="datesUpdated($event)"
                           [keepCalendarOpeningWithRange]="keepCalendarOpeningWithRange"
                           [showRangeLabelOnInput]="showRangeLabelOnInput"
                           class="form-control"/>
                </div>
            </div>
        </div>

        <div class="panel-quotes masonry-with-flex" infiniteScroll
                                           infiniteScrollDistance="1"
                                           (scrolled)="onScroll()">
            <div class="panel-quotes-wrapper" *ngFor="let mention of pages | paginate: { itemsPerPage: page_length, currentPage: page, totalItems: total }" [style.display]="can_show_mention(mention.id, mention.profile_id)">
                <div class="panel-quotes_card">
                    <a href="" class="panel-quotes_icon" target="_blank">
                        <img src="assets/images/twitter_q.png" style="max-width: 40px; margin: 5px 10px;">
                    </a>
                    <div class="panel-quotes_quote-text">
                        <span class="panel-quotes_quote-mark">”</span>
                        {{mention.description}}
                    </div>
                    <div class="panel-quotes_quote-meta">
                        <div class="img-qu">
                            <img class="img-avatar" src="{{mention.profile_image}}" width="32" height="32" border="0">
                        </div>
                        <br>
                        <a (click)="viewQuote(mention)">{{mention.name}}</a> 
                        <br>
                        <time>{{change_date_format(mention.pub_datetime, 'YYYY-MM-DD hh:mm a')}}</time>
                        <div class="options">
                            <ul id="side-menu3"> 
                                <li *ngIf="mention.sentiment_text"><a title="{{mention.sentiment_text}}"><img src="assets/images/sentiment/{{mention.sentiment_text}}.png"></a></li>
                                <li *ngIf="mention.lang_detected"><a title="Language"><i class="fa fa-language" aria-hidden="true"></i>{{mention.lang_detected}}</a></li>
                                <li *ngIf="mention.mEngagement"><a title="Engagement"><i class="fa fa-share-alt" aria-hidden="true"></i>{{mention.mEngagement}}</a></li>
                                <li *ngIf="mention.profile_meta_count1"><a title="Rank"><i class="fa fa-line-chart" aria-hidden="true"></i>{{mention.profile_meta_count1}}</a></li>
                                <li *ngIf="mention.followers_count"><a title="Followers"><i class="fa fa-users" aria-hidden="true"></i>{{mention.followers_count}}</a></li>
                                <li *ngIf="mention.relevance"><a title="Relevance"><i class="fa fa-signal" aria-hidden="true"></i>{{mention.relevance}}</a></li>
                                <li *ngIf="mention.country"><img title="{{country_filter(mention.country, 'name')}}" src="assets/images/flags/{{mention.country.toLowerCase()}}.png" onError="this.src=''"></li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>			
        </div>
        <div *ngIf="total == 0" class="mention-card">
            There are no results for your search.
        </div>
<!--        <div class="mention-card" *ngIf="total != 0">
            <div class="paginate_sec_bottom">
                <pagination-controls (pageChange)="pageChanged($event)" responsive="true"></pagination-controls>
            </div>
        </div>-->
    </div>
</div>
<ngx-spinner bdColor = "rgba(0, 0, 0, 0.8)" size = "medium" color = "rgb(199, 28, 109)" type = "square-loader" [fullScreen] = "true"></ngx-spinner>
<app-footer></app-footer>